export default __webpack_public_path__ + "static/great-wall-399821f03c3e2fd0a638db61347cf311.jpg";